import { BaseSendEmailMeta } from '@pflegia/types/common/email/base-send-email-meta';
import { EmailClient } from '@pflegia/types/common/enums/email-client.enum';
import { EmailRecognition } from '@pflegia/types/common/enums/email-recognition.enum';

import { AppName } from '../general';
import { CancelEmailTemplate, ConfirmEmailTemplate, EmailCategory, RequestEmailTemplate } from '../match';
import { EmailSubType } from './email-sub-type';
import { EmailType } from './email-type';

export const EMAIL_CATEGORY_TEMPLATE_TO_EMAIL_TYPE: Record<string, EmailType | Record<string, EmailType>> = {
  [EmailCategory.Cancel]: {
    [CancelEmailTemplate.CandidateCancel]: EmailType.InterviewCancellation,
    [CancelEmailTemplate.Cancel]: EmailType.Cancellation,
  },
  [EmailCategory.Confirm]: EmailType.InterviewConfirmation,
  [EmailCategory.Create]: EmailType.MatchesMail,
  [EmailCategory.Request]: {
    [RequestEmailTemplate.RequestFinal]: EmailType.StatusQueryFinal,
    [RequestEmailTemplate.RequestHt]: EmailType.StatusQueryHt,
    [RequestEmailTemplate.RequestStatus]: EmailType.StatusQueryOne,
    [RequestEmailTemplate.RequestStatusFollowUp]: EmailType.StatusQueryTwo,
    [RequestEmailTemplate.RequestVt]: EmailType.StatusQueryVt,
  },
};

export const CONFIRM_EMAIL_TEMPLATE_TO_EMAIL_SUB_TYPE: Record<string, EmailSubType> = {
  [ConfirmEmailTemplate.ConfirmVt]: EmailSubType.Vt,
  [ConfirmEmailTemplate.ConfirmHt]: EmailSubType.Ht,
  [ConfirmEmailTemplate.ConfirmDigital]: EmailSubType.Digital,
  [ConfirmEmailTemplate.ConfirmPhone]: EmailSubType.Phone,
  [ConfirmEmailTemplate.Avu]: EmailSubType.Avu,
};

export type SendEmailMeta = BaseSendEmailMeta<EmailSubType>;

export interface EmailHistoryMeta extends SendEmailMeta {
  client?: EmailClient;
  externalId?: string;
  recognition?: EmailRecognition;
}

export const EMAIL_LOGO_FROM_APP_NAME = {
  [AppName.Pflegia]: `https://cdn.mcauto-images-production.sendgrid.net/a51eee780ed797be/fc2f12d7-d8a3-4d1a-987e-118b3bff9615/607x304.png`,
  [AppName.Praxia]: `https://cdn.mcauto-images-production.sendgrid.net/a51eee780ed797be/d70ff749-a0a1-47a3-ad30-0b48f3148c58/607x266.png`,
  [AppName.Docia]: 'https://cdn.mcauto-images-production.sendgrid.net/a51eee780ed797be/2eab1e05-07bd-44cf-aa91-910ed333ffa3/300x156.png',
};

export * from '@pflegia/types/common/constants/graph-api';

export const USER_NAME_FOR_EMAIL = 'Isabel';
